module.exports = __webpack_public_path__ + "img/opened_book.257e7090.svg";